import { render, staticRenderFns } from "./QQVisualizzaQuestionario.vue?vue&type=template&id=5a9731b5&scoped=true&"
import script from "./QQVisualizzaQuestionario.vue?vue&type=script&lang=js&"
export * from "./QQVisualizzaQuestionario.vue?vue&type=script&lang=js&"
import style0 from "./QQVisualizzaQuestionario.vue?vue&type=style&index=0&id=5a9731b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9731b5",
  null
  
)

export default component.exports